import { Box, Button, Center, Flex, Heading, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react';


const Feature = ({ title, text, icon }) => {
    return (
        <Stack>
            <Center>
                <Image boxSize='200px' src={icon} alt='Dan Abramov' />
            </Center>
            <Center>
                <Text fontWeight={300} fontSize="35px">{title}</Text>
            </Center>
            <Center>
                <Text fontSize="20px" textAlign="center">{text}</Text>
            </Center>
        </Stack>
    );
};

export default function GettingStarted(props) {
    const { onOpenLoginModal } = props;

    return (
        <Stack align="center" px={{ base: "14px", sm: "10vw" }} mb="150px" fontWeight="300" color="#1C3E64">
            <Stack maxW="1140px" direction={{ base: 'column', md: 'row' }} fontWeight="300">
                <Flex w="100%" flex={1} align={'center'} justify={'center'}>
                    <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
                        <Text
                            fontSize="41px"
                            fontWeight="300"
                            pb="8px"
                            borderBottom="1px solid rgba(28, 62, 100, 0.50)"

                        >
                            Getting Started is Easy
                        </Text>
                        <br />{' '}
                    </Heading>
                </Flex>
            </Stack>
            <SimpleGrid maxW="1140px" columns={{ base: 1, md: 3 }} spacing={1}>
                <Center>
                    <Feature
                        icon={"https://redswan.io/wp-content/uploads/2023/03/selectproperty_1.png"}
                        title={'Sign In/Up'}
                        text={'Sign up to get an account'}
                    />
                </Center>
                <Center>
                    <Feature
                        icon={"https://redswan.io/wp-content/uploads/2023/03/signup2.png"}
                        title={'Select a Property'}
                        text={'Select your desired property'}
                    />
                </Center>
                <Center>
                    <Feature
                        icon={"https://redswan.io/wp-content/uploads/2023/03/startinvesting3.png"}
                        title={'Start Investing'}
                        text={'You are on your way to owning real estate shares'}
                    />
                </Center>
            </SimpleGrid>
            <Flex mt="80px" flex={1} align={'center'} justify={'center'}>
                <Button
                    _hover={{
                        color: "#002B5B",
                        bgColor: "white",
                        border: "1px solid #002B5B"
                    }}
                    bgColor="#002B5B"
                    color="white"
                    p="12px 24px"
                    onClick={onOpenLoginModal}
                >
                    Get Started Now
                </Button>
            </Flex>
        </Stack>
    );
}